import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-animal-group',
  templateUrl: './animal-group.component.html',
  imports: [RouterOutlet],
})
export class AnimalGroupComponent {}
